import React from 'react';
import './App.css'
import AboutMe from './AboutMe.js'
import Skills from './Skills.js'
import Life from './Life.js'
function App() {
    return (
        <React.Fragment>
            <AboutMe></AboutMe>
            <Skills></Skills>
            <Life></Life>
        </React.Fragment>
    );
}

export default App;
